import { create } from 'zustand';

export type Theme = 'sombre' | 'clair';

const CLE = 'astrolabe:theme';

/** Lit le theme deja pose sur <html> par le script inline de `index.html`. */
function themeInitial(): Theme {
  if (typeof document === 'undefined') return 'sombre';
  return document.documentElement.dataset.theme === 'clair' ? 'clair' : 'sombre';
}

interface EtatTheme {
  theme: Theme;
  definir: (theme: Theme) => void;
  basculer: () => void;
}

/**
 * Theme sombre/clair.
 *
 * La bascule ecrit un attribut sur <html> ; toutes les couleurs sont des variables
 * CSS (voir `styles/theme.css`). Aucun composant React ne se re-rend pour changer
 * de theme — c'est instantane et sans cout de rendu.
 *
 * Le theme initial est pose AVANT le premier rendu par un script inline dans
 * `index.html`. Ce store se contente donc de reprendre l'etat en place, sans
 * jamais provoquer de flash.
 */
export const useTheme = create<EtatTheme>()((set, get) => ({
  theme: themeInitial(),

  definir(theme) {
    document.documentElement.dataset.theme = theme;

    try {
      localStorage.setItem(CLE, theme);
    } catch {
      // Stockage indisponible : le choix ne survivra pas au rechargement,
      // mais la bascule fonctionne pour la session en cours.
    }

    set({ theme });
  },

  basculer() {
    get().definir(get().theme === 'sombre' ? 'clair' : 'sombre');
  },
}));
